import React from 'react'

export const ScrollbarOffsetContext = React.createContext({
  isWithinOffsetView: false,
})
